import { SearchIcon } from 'lucide-react'
import { Input } from '../input/Input'
import { ChangeEventHandler } from 'react'
import { cn } from '@/ui/utils/style'

interface SearchInputProps {
  value: string
  placeholder: string
  autoFocus?: boolean
  className?: string
  onChange: ChangeEventHandler<HTMLInputElement>
}

export function SearchInput({ value, placeholder, autoFocus, className, onChange }: SearchInputProps) {
  return (
    <div className="relative flex items-center">
      <SearchIcon className="absolute left-3 h-5 w-5 text-muted-foreground" />
      <Input
        placeholder={placeholder}
        className={cn(
          'w-full rounded-sm border border-border bg-input py-6 pl-10 text-sm placeholder:text-muted-foreground',
          className,
        )}
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
      />
    </div>
  )
}
